import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

export default function CashoutOnboardingBanner({ onClose }) {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div className="alert alert-info cashout-banner cashout-onboarding-banner" role="alert">
      <button
        type="button"
        className="close"
        aria-label="Close"
        onClick={onClose}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <p>
        <Trans i18nKey="cashout-onboarding-banner" t={t} components={{ br: <br /> }} />
      </p>
    </div>
  );
}

CashoutOnboardingBanner.propTypes = {
  onClose: PropTypes.func.isRequired,
};
